export * from './hiddenRoadAccountsController.service';
import { HiddenRoadAccountsControllerService } from './hiddenRoadAccountsController.service';
export * from './hiddenRoadPartnersController.service';
import { HiddenRoadPartnersControllerService } from './hiddenRoadPartnersController.service';
export const APIS = [HiddenRoadAccountsControllerService, HiddenRoadPartnersControllerService];
